import { useEffect, useRef, useState } from "react";
import AsyncSelect from "react-select/async";

import { getStores } from "../../../MyApi/stores";
import SkeletonWrapper from "../skeletonWrapper";

const EnhancedSearchStore = ({
  setStoreId,
  value,
  setSectionType,
  setPrices,
  setSectionId,
  product,
  setErrors,
  disabled,  
  isMulti,
  type
  
}) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const timeOutId = useRef(null);
  const [defaultStores, setDefaultStores] = useState([]);
console.log('debugvalue', type)
  useEffect(() => {
    if (!value || !defaultStores.length) {
      setSelectedOption(null);
      return;
      
    }

    setSelectedOption(value);
  }, [defaultStores ,value ]);

  useEffect(() => {
    const fetchDefaultStores = async () => {
      setLoading(true);
      try {
        const res = await getStores("","",type);
        setDefaultStores(res?.data?.Stores || []);
      } catch (err) {
        setDefaultStores([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDefaultStores();
  }, []);
  const handelSearch = (selectedOptions) => {
    if (!selectedOptions) {
      setStoreId("");
      setSelectedOption(null);
      return;
    }
    setSelectedOption(selectedOptions);
    const storeId = selectedOptions ? selectedOptions.id : "";
    const storedName =selectedOptions ?selectedOptions.name:""
    if (isMulti) {
      setStoreId(selectedOptions);
    } else {
      setStoreId(storeId , storedName);
    }
    console.log(selectedOptions.section_type, "sectionType");

    if (product) {
      setSectionId(selectedOptions.section_id);
      setSectionType(selectedOptions.section_type);
      setPrices((prev) => ({
        ...prev,
        currency_factor: +selectedOptions.currency_factor,
      }));
    }
  };
  const enhancedSearchStores = (value) => {
    return new Promise((resolve) => {
      if (value.length >= 5) {
        clearTimeout(timeOutId.current);
        timeOutId.current = setTimeout(async () => {
          try {
            let res = await getStores("", { search: value } ,type);
            resolve(res.data.Stores || []);
          } catch (error) {
            resolve([]);
          }
        }, 500);
      } else {
        resolve([]);
      }
    });
  };
  return (
    <SkeletonWrapper isLoading={isLoading}>
      <AsyncSelect
        getOptionValue={(e) => e.id}
        getOptionLabel={(e) => e.name}
        loadOptions={enhancedSearchStores}
        value={selectedOption}
        onChange={handelSearch}
        defaultOptions={defaultStores}
        placeholder="اختار المتجر"
        isClearable
        isDisabled={disabled || isLoading}
        isLoading={isLoading}
        isMulti={isMulti}
      />
    </SkeletonWrapper>
  );
};

export default EnhancedSearchStore;
